import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NotificationFacade, PurchaseFacade, ReceiptService } from '@ridango/components';
import { ReceiptFacade } from '@ridango/components/lib/receipt/+state';
import { BaseComponent } from '@ridango/core';
import { Observable } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-purchase-invoice',
    templateUrl: './purchase-invoice.component.html'
})
export class PurchaseInvoiceComponent extends BaseComponent implements OnDestroy {
    locale = this.translate.currentLang;
    loading$: Observable<boolean> = this.purchaseFacade.invoiceLoading$;

    @Input() token;
    @Output() scrollUp = new EventEmitter<void>();

    invoiceForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email])
    });

    constructor(
        private receiptFacade: ReceiptFacade,
        private translate: TranslateService,
        private purchaseFacade: PurchaseFacade,
        private receiptService: ReceiptService,
        private notifications: NotificationFacade
    ) {
        super();
    }

    sendInvoiceToEmail() {
        if (!this.invoiceForm.valid) {
            return;
        }
        this.receiptService
            .sendToEmail(this.translate.currentLang, this.invoiceForm.controls.email.value, this.token)
            .pipe(
                takeUntil(this.componentDestroyed$),
                finalize(() => {
                    this.scrollUp.emit();
                    window.scroll(0, 0);
                })
            )
            .subscribe(
                () => {
                    this.notifications.success(this.translate.instant('LOCAL_RECIEPT_SENT_TO_EMAIL_SUCCESS'));
                },
                () => {
                    this.notifications.error(this.translate.instant('LOCAL_RECIEPT_SENT_TO_EMAIL_ERROR'));
                }
            );
    }

    downloadInvoice() {
        this.receiptFacade.getPdf(this.translate.currentLang, this.token);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
